// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2gk-P","title":"AfterBackImages_title__1U2tm","images":"AfterBackImages_images__1tHTr"};